import resultLineBg from "./result/result-bg-line.png";
import resultGiftIcon from "./result/result.png";
import infoIcon from "./result/info-icon.svg";
import tncChecked from "./home/checkbox-checked.svg";
import tncUnchecked from "./home/checkbox-unchecked.svg";
import closeTncPopup from "./common/icon-close.svg";
import marker from "./home/marker.png";
import redMarker from "./home/red-marker.png";
import dialAgain from "./result/dial-again.png"

export const imageKeyMappings = {
  resultLineBg: resultLineBg,
  resultGiftIcon: resultGiftIcon,
  infoIcon: infoIcon,
  tncUnchecked: tncUnchecked,
  tncChecked: tncChecked,
  closeTncPopup: closeTncPopup,
  marker: marker,
  redMarker: redMarker,
  dialAgain:dialAgain
};
